import React from 'react'
import "./nav_top_style.css"

export default function NavTop() {
  return (
    <div className='nav_top'>
        <h1 className='title'>HARDWARE HERO</h1>
    </div>
  )
}
